module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " a ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " selecionado");
  },
  "finishRangeSelectionPrompt": "Clique para terminar de selecionar o intervalo de datas",
  "maximumDate": "\xDAltima data dispon\xEDvel",
  "minimumDate": "Primeira data dispon\xEDvel",
  "next": "Pr\xF3ximo",
  "previous": "Anterior",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Data selecionada: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Intervalo selecionado: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Clique para come\xE7ar a selecionar o intervalo de datas",
  "todayDate": function todayDate(args) {
    return "Hoje, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Hoje, ".concat(args.date, " selecionado");
  }
};